module.exports = __webpack_public_path__ + "img/dancing-colored-icon.45029ba6.svg";